import { Injectable } from '@angular/core';
import { SiteClassificationType } from '@services/cleanfill-api/cleanfill-api.generated';

@Injectable({
  providedIn: 'root'
})
export class SoilClassificationMapper {
  constructor() {}
  getLabel(siteClassificationType: SiteClassificationType): string {
    switch (siteClassificationType) {
      case SiteClassificationType.Class1SoilManagementSite:
        return 'Class 1 Soil Management Site';
      case SiteClassificationType.Class2SoilManagementSite:
        return 'Class 2 Soil Management Site';
      case SiteClassificationType.LandFillingSiteOrDump:
        return 'Landfilling site or Dump';
      case SiteClassificationType.ReUseSite:
        return 'Re-use Site';
      default:
        return '';
    }
  }
}
